import React from 'react';
import {
  Typography,
} from "@material-tailwind/react";
import PresentationTarifs from '../../../images/Presentation_Tarifs.jpg';

const PresentationPersonnelle = () => {
  return ( 
	<div className="w-5/6 mx-auto lg:w-3/6">
		<Typography id="Tarifs" variant="h4" color="blue-gray" className="mb-2">Tarifs</Typography>
		<div className="lg:flex lg:columns-2">
			<div className="w-full lg:w-4/6 pl-1 lg:pl-0 mx-auto text-justify gap-2 flex flex-col">
				<Typography variant="small" color="blue-gray" className="text-justify"><span className="font-bold">Accord</span> - 110 €</Typography>
				<Typography variant="small" color="blue-gray"><span className="font-bold">Mise au diapason</span> - 30 €</Typography>
				<Typography variant="small" color="blue-gray" className="italic">La mise au diapason est une opération généralement nécessaire  : </Typography>
				<div id="InfoDiapason" className="ml-2 text-sm italic">
					<ul className="list-disc ml-6 font-sans text-blue-gray-900">
						<li><Typography variant="small" color="blue-gray" className="italic">Lorsque le dernier accord de votre instrument remonte à plus de 2 ans</Typography></li>
						<li><Typography variant="small" color="blue-gray" className="italic">Lorsque le piano a été déménagé</Typography></li>
						<li><Typography variant="small" color="blue-gray" className="italic">Lorsque le piano a été exposé à des variations climatiques importantes</Typography></li>
						{/* Necessary to repeat typography on each line because higher font definition does not seem to impact li nodes on firefox on Android phone*/}
					</ul>
				</div>
				<Typography variant="small" color="blue-gray"><span className="font-bold">Réparations</span> - Sur devis</Typography>
				<Typography variant="small" color="blue-gray"><span className="font-bold">Réglages et harmonisation</span> - Sur devis</Typography>
			</div>
			<div className="w-3/6 lg:w-2/6 mx-auto">
				<img alt="nature" className="rounded-xl lg:w-5/6 max-h-[50vh] mx-auto" src={PresentationTarifs}/>
			</div>
		</div>
	</div>
	)
};

export default PresentationPersonnelle;
